import { render, staticRenderFns } from "./DetailValues.vue?vue&type=template&id=80281e70&scoped=true"
import script from "./DetailValues.vue?vue&type=script&lang=js"
export * from "./DetailValues.vue?vue&type=script&lang=js"
import style0 from "./DetailValues.vue?vue&type=style&index=0&id=80281e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80281e70",
  null
  
)

export default component.exports